export enum OpenApiPlatformAccessOperation {
    create = "30734fd9-cd23-4146-ac9e-3fcf31e73463",
    read = "3dee6649-812d-4366-ab11-f1257f0b1c66",
    update = "44e43e50-d98e-4e2a-95a7-a7434840e42f",
    delete = "c215abf2-6a53-4d43-816a-51e1e38a8622",
}
